import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\GetPersonByIdController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdController.php
* @route '/api/person/{mergeablePerson}'
*/
const GetPersonByIdController = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPersonByIdController.url(args, options),
    method: 'get',
})

GetPersonByIdController.definition = {
    methods: ["get","head"],
    url: '/api/person/{mergeablePerson}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Person\GetPersonByIdController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdController.php
* @route '/api/person/{mergeablePerson}'
*/
GetPersonByIdController.url = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mergeablePerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { mergeablePerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            mergeablePerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mergeablePerson: typeof args.mergeablePerson === 'object'
        ? args.mergeablePerson.id
        : args.mergeablePerson,
    }

    return GetPersonByIdController.definition.url
            .replace('{mergeablePerson}', parsedArgs.mergeablePerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\GetPersonByIdController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdController.php
* @route '/api/person/{mergeablePerson}'
*/
GetPersonByIdController.get = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPersonByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Person\GetPersonByIdController::__invoke
* @see app/Http/Controllers/Person/GetPersonByIdController.php
* @route '/api/person/{mergeablePerson}'
*/
GetPersonByIdController.head = (args: { mergeablePerson: string | number | { id: string | number } } | [mergeablePerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPersonByIdController.url(args, options),
    method: 'head',
})

export default GetPersonByIdController